var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from "class-transformer";
import { IsBoolean, IsDateString, IsEnum, IsInt, IsNumber, IsOptional, IsString, Matches, Min, ValidateNested, } from "class-validator";
import { ErrorCode } from "../../error";
import { safeAssign } from "./safe-assign";
const TIME_PATTERN = /^([01]\d|2[0-3]):[0-5]\d$/;
export var ShiftProgress;
(function (ShiftProgress) {
    /** No recorded times lie in the past yet */
    ShiftProgress["Planned"] = "planned";
    /** The recorded start lies in the past */
    ShiftProgress["InProgress"] = "in_progress";
    /** The recorded end lies in the past */
    ShiftProgress["Completed"] = "completed";
})(ShiftProgress || (ShiftProgress = {}));
export var ShiftPublishStatus;
(function (ShiftPublishStatus) {
    /** Never published */
    ShiftPublishStatus["Draft"] = "draft";
    /** Published, snapshot matches the current state */
    ShiftPublishStatus["Published"] = "published";
    /** Edited since it was last published */
    ShiftPublishStatus["ChangedSinceLastPublished"] = "changed_since_last_published";
})(ShiftPublishStatus || (ShiftPublishStatus = {}));
export class ShiftDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], ShiftDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", String)
], ShiftDTO.prototype, "date", void 0);
__decorate([
    Expose(),
    IsInt(),
    IsOptional(),
    __metadata("design:type", Object)
], ShiftDTO.prototype, "employeeId", void 0);
__decorate([
    Expose(),
    IsInt(),
    __metadata("design:type", Number)
], ShiftDTO.prototype, "positionId", void 0);
__decorate([
    Expose(),
    IsInt(),
    IsOptional(),
    __metadata("design:type", Object)
], ShiftDTO.prototype, "venueId", void 0);
__decorate([
    Expose(),
    Matches(TIME_PATTERN),
    IsOptional(),
    __metadata("design:type", Object)
], ShiftDTO.prototype, "start", void 0);
__decorate([
    Expose(),
    Matches(TIME_PATTERN),
    IsOptional(),
    __metadata("design:type", Object)
], ShiftDTO.prototype, "end", void 0);
__decorate([
    Expose(),
    Type(() => Date),
    IsOptional(),
    __metadata("design:type", Object)
], ShiftDTO.prototype, "startsAt", void 0);
__decorate([
    Expose(),
    Type(() => Date),
    IsOptional(),
    __metadata("design:type", Object)
], ShiftDTO.prototype, "endsAt", void 0);
__decorate([
    Expose(),
    IsInt(),
    IsOptional(),
    __metadata("design:type", Object)
], ShiftDTO.prototype, "breakMinutes", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], ShiftDTO.prototype, "comment", void 0);
__decorate([
    Expose(),
    IsEnum(ShiftProgress),
    __metadata("design:type", String)
], ShiftDTO.prototype, "progress", void 0);
__decorate([
    Expose(),
    IsEnum(ShiftPublishStatus),
    __metadata("design:type", String)
], ShiftDTO.prototype, "publishStatus", void 0);
__decorate([
    Expose(),
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Object)
], ShiftDTO.prototype, "plannedHours", void 0);
__decorate([
    Expose(),
    Matches(TIME_PATTERN),
    IsOptional(),
    __metadata("design:type", Object)
], ShiftDTO.prototype, "workedStart", void 0);
__decorate([
    Expose(),
    Matches(TIME_PATTERN),
    IsOptional(),
    __metadata("design:type", Object)
], ShiftDTO.prototype, "workedEnd", void 0);
__decorate([
    Expose(),
    Type(() => Date),
    IsOptional(),
    __metadata("design:type", Object)
], ShiftDTO.prototype, "workedStartsAt", void 0);
__decorate([
    Expose(),
    Type(() => Date),
    IsOptional(),
    __metadata("design:type", Object)
], ShiftDTO.prototype, "workedEndsAt", void 0);
__decorate([
    Expose(),
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Object)
], ShiftDTO.prototype, "workedHours", void 0);
__decorate([
    Expose(),
    Type(() => Date),
    __metadata("design:type", Date)
], ShiftDTO.prototype, "updated", void 0);
__decorate([
    Expose(),
    Type(() => Date),
    IsOptional(),
    __metadata("design:type", Object)
], ShiftDTO.prototype, "deletedAt", void 0);
export class GetShiftsDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", String)
], GetShiftsDTO.prototype, "from", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", String)
], GetShiftsDTO.prototype, "to", void 0);
__decorate([
    Expose(),
    IsInt({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], GetShiftsDTO.prototype, "employeeIds", void 0);
__decorate([
    Expose(),
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], GetShiftsDTO.prototype, "venueId", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetShiftsDTO.prototype, "includeUnassigned", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetShiftsDTO.prototype, "publishedOnly", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], GetShiftsDTO.prototype, "includeDeleted", void 0);
export class CreateShiftDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", String)
], CreateShiftDTO.prototype, "date", void 0);
__decorate([
    Expose(),
    IsInt(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateShiftDTO.prototype, "employeeId", void 0);
__decorate([
    Expose(),
    IsInt(),
    __metadata("design:type", Number)
], CreateShiftDTO.prototype, "positionId", void 0);
__decorate([
    Expose(),
    Matches(TIME_PATTERN),
    __metadata("design:type", String)
], CreateShiftDTO.prototype, "start", void 0);
__decorate([
    Expose(),
    Matches(TIME_PATTERN),
    __metadata("design:type", String)
], CreateShiftDTO.prototype, "end", void 0);
__decorate([
    Expose(),
    IsInt(),
    Min(0),
    IsOptional(),
    __metadata("design:type", Number)
], CreateShiftDTO.prototype, "breakMinutes", void 0);
__decorate([
    Expose(),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreateShiftDTO.prototype, "comment", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], CreateShiftDTO.prototype, "publish", void 0);
export class UpdateShiftDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], UpdateShiftDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    IsDateString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateShiftDTO.prototype, "date", void 0);
__decorate([
    Expose(),
    IsInt(),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateShiftDTO.prototype, "employeeId", void 0);
__decorate([
    Expose(),
    IsInt(),
    IsOptional(),
    __metadata("design:type", Number)
], UpdateShiftDTO.prototype, "positionId", void 0);
__decorate([
    Expose(),
    Matches(TIME_PATTERN),
    IsOptional(),
    __metadata("design:type", String)
], UpdateShiftDTO.prototype, "start", void 0);
__decorate([
    Expose(),
    Matches(TIME_PATTERN),
    IsOptional(),
    __metadata("design:type", String)
], UpdateShiftDTO.prototype, "end", void 0);
__decorate([
    Expose(),
    IsInt(),
    Min(0),
    IsOptional(),
    __metadata("design:type", Object)
], UpdateShiftDTO.prototype, "breakMinutes", void 0);
__decorate([
    Expose(),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], UpdateShiftDTO.prototype, "comment", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], UpdateShiftDTO.prototype, "publish", void 0);
__decorate([
    Expose(),
    Type(() => Date),
    IsOptional(),
    __metadata("design:type", Date)
], UpdateShiftDTO.prototype, "lastKnownUpdated", void 0);
export class DeleteShiftDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], DeleteShiftDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], DeleteShiftDTO.prototype, "publish", void 0);
__decorate([
    Expose(),
    Type(() => Date),
    IsOptional(),
    __metadata("design:type", Date)
], DeleteShiftDTO.prototype, "lastKnownUpdated", void 0);
export var ShiftWarningCode;
(function (ShiftWarningCode) {
    /** Overlaps another shift of the same employee */
    ShiftWarningCode["Overlap"] = "overlap";
    /** Violates the minimum rest period between two shifts */
    ShiftWarningCode["RestPeriod"] = "rest_period";
    /** Exceeds the maximum planned hours for the day */
    ShiftWarningCode["MaxDailyHours"] = "max_daily_hours";
})(ShiftWarningCode || (ShiftWarningCode = {}));
export class ShiftWarningDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsEnum(ShiftWarningCode),
    __metadata("design:type", String)
], ShiftWarningDTO.prototype, "code", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], ShiftWarningDTO.prototype, "message", void 0);
export class ShiftResultDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    ValidateNested(),
    Type(() => ShiftDTO),
    __metadata("design:type", ShiftDTO)
], ShiftResultDTO.prototype, "shift", void 0);
__decorate([
    Expose(),
    ValidateNested({ each: true }),
    Type(() => ShiftWarningDTO),
    __metadata("design:type", Array)
], ShiftResultDTO.prototype, "warnings", void 0);
/** The rejection that stopped a shift batch; the item at `index` and every later one were not applied */
export class ShiftBatchErrorDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsInt(),
    Min(0),
    __metadata("design:type", Number)
], ShiftBatchErrorDTO.prototype, "index", void 0);
__decorate([
    Expose(),
    IsEnum(ErrorCode),
    __metadata("design:type", String)
], ShiftBatchErrorDTO.prototype, "code", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], ShiftBatchErrorDTO.prototype, "message", void 0);
/**
 * Items are applied in order and not atomically: processing stops at the first rejection, so
 * `results` holds one entry per item applied before it — these writes are saved. A rejected item
 * was not written, except with `server_error`: then it failed unexpectedly and may or may not have
 * been saved, so read it back before retrying it.
 */
export class ShiftBatchResultDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    ValidateNested({ each: true }),
    Type(() => ShiftResultDTO),
    __metadata("design:type", Array)
], ShiftBatchResultDTO.prototype, "results", void 0);
__decorate([
    Expose(),
    ValidateNested(),
    Type(() => ShiftBatchErrorDTO),
    IsOptional(),
    __metadata("design:type", Object)
], ShiftBatchResultDTO.prototype, "error", void 0);
//# sourceMappingURL=shift.dto.js.map